import React, {PureComponent, ReactNode} from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

// Define the state interface
interface FastRegistrationPromocodeState {
    isInputVisible: boolean;
}

export default class FastRegistrationPromocode extends PureComponent<object, FastRegistrationPromocodeState> {
    constructor(props: object) {
        super(props);
        this.state = {
            isInputVisible: false
        };
    }

    toggleInputVisibility = (): void => {
        this.setState(prevState => ({
            isInputVisible: !prevState.isInputVisible
        }));
    };

    render(): ReactNode {
        const {isInputVisible} = this.state;

        return (
            <div className="registration-promocode active">
                <div className="registration-promocode__title">
                    <button
                        type="button"
                        className="button-registration"
                        onClick={this.toggleInputVisibility}
                    >
                        <span className="icon">
                            <SpriteIcon name="#svg-add" className="svg-default"/>
                        </span>
                        <span className="name">{I18n.t('have_promo_code')}</span>
                    </button>
                </div>
                {isInputVisible &&
                    <input
                        className="field__input"
                        id="field-promocode"
                        name="promocode"
                        placeholder={I18n.t('enter_promocode')}
                    />
                }
                <div className="registration-sign-with__divider" />
            </div>
        );
    }
}
